import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=4308efa6"
import script from "./SupportForm.vue?vue&type=script&lang=js"
export * from "./SupportForm.vue?vue&type=script&lang=js"
import style0 from "./SupportForm.vue?vue&type=style&index=0&id=4308efa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports